<script setup lang="ts">

import {onMounted} from "vue";
import axios from "axios";
import {customerStore} from "../customer.store";
import {storeToRefs} from "pinia";
import {useWebPopup} from "lct-lib";
const {show} = useWebPopup();
const {customer} = storeToRefs(customerStore());

const handleCredentialResponse = async (response: any) => {
    //console.log("JWT ID token nhận được:", response.credential);
    // Sau đó gửi token này đến server của bạn để xác thực

    const result = await axios.post("https://sv.lct.vn/auth/google/callback", {token: response.credential});
    console.log(result);
    customer.value = result.data;
    show("You have successfully logged in.", ()=>{
        location.href = "/";
    });



};

onMounted(() => {
    // Đảm bảo đối tượng google đã được tải
    if (window.google && google.accounts) {
        google.accounts.id.initialize({
            client_id: '182755132918-dnvbgefpmjsko7tpfmkdgsla00vmut1m.apps.googleusercontent.com', // thay YOUR_GOOGLE_CLIENT_ID bằng Client ID thực
            callback: handleCredentialResponse
        });
        google.accounts.id.renderButton(
            document.getElementById("google-button"),
            { theme: "outline", size: "large" }  // Tùy chỉnh giao diện nút theo ý bạn
        );
    }
});

</script>

<template>
    <div>
        <!-- Đây là container để render nút đăng nhập -->
        <div id="google-button"></div>
    </div>
</template>

<style scoped>

</style><style lang="scss" scoped></style>